import asiox from "axios";
import { tpcOsAxios } from "../../Utils/IntitialAxios";
import { failRequestHandler } from "./globalSetting";

export function post(url, data, config) {
  return request({
    url: url,
    method: "post",
    data: data,
    ...config,
  });
}

export function get(url, config) {
  return request({
    url: url,
    method: "get",
    ...config,
  });
}

let cancelCollection = {};
const CancelToken = asiox.CancelToken;
function request(config) {
  let promise = new Promise((reslove, reject) => {
    //create cancel token
    //for cancel when component unmount
    const cancelObj = {
      isFinished: false,
      key: randomString(),
      config,
    };

    config.cancelToken = new CancelToken((c) => (cancelObj.cancelToken = c));
    cancelCollection[cancelObj.key] = cancelObj;

    tpcOsAxios(config)
      .then((response) => {
        cancelObj.isFinished = true;

        if (response.status === 401) {
          reject({ status: 401, message: "Authenticate is require!" });
        } else if (response.status === 400) {
          failRequestHandler(response.data);
          reject({ status: 400, message: response.data.Error ?? response.data });
        } else if (
          response.headers["content-type"] === "application/octet-stream"
        ) {
          reslove(response);
        } else reslove(response.data);
      })
      .catch((error) => {
        cancelObj.isFinished = true;

        if (!asiox.isCancel(error)) {
          failRequestHandler(error);
          reject({
            status: 444,
            message: "Axios error, please inspect to see detail",
          });
        }
      });
  });
  return promise;
}

let cancelLock = Promise.resolve();
export async function cancelAllWork() {
  // need to local copy, to avoid condition race
  const cancelKeys = Object.keys(cancelCollection);

  await cancelLock;

  cancelLock = new Promise((resolve) => {
    console.log("clear cancel", [cancelKeys]);
    cancelKeys.forEach((key) => {
      const obj = cancelCollection[key];
      delete cancelCollection[key];
      if (obj && !obj.isFinished) {
        obj.isFinished = true;
        obj.cancelToken();
      }
    });

    resolve();
  });
}

function randomString() {
  return (Math.random() + 1).toString(36).substring(2);
}
